import { FETCH_LOGIN_DATA_REQUEST, FETCH_LOGIN_DATA_SUCCESS, FETCH_LOGIN_DATA_FAILURE } from './LoginTypes'
const initialState = {
    loading: false,
    data: [],
    error: ''
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LOGIN_DATA_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_LOGIN_DATA_SUCCESS:
            return {
                loading: false,
                data: action.payload.data
            }
        case FETCH_LOGIN_DATA_FAILURE:
            return {
                loading: false,
                error: action.payload
            }

        default:
            return state;
    }
}
export default reducer;